export const SelectedLeagueFromMyLeagues = 'pff:selectedLeagueIdFromMyLeagues'
